"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;
var _styles = require("@mui/material/styles");
var _GlobalStyles = _interopRequireDefault(require("@mui/material/GlobalStyles"));
var _useThemeSwitcher2 = require("./useThemeSwitcher");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ThemeProvider = exports.ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  var _useThemeSwitcher = (0, _useThemeSwitcher2.useThemeSwitcher)(),
    theme = _useThemeSwitcher.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledEngineProvider, {
    injectFirst: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ThemeProvider, {
      theme: theme,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GlobalStyles["default"], {
        styles: function styles(theme) {
          return {
            body: {
              backgroundColor: theme.palette.background["default"]
            },
            '*::-webkit-scrollbar': {
              background: 'transparent'
            },
            '*::-webkit-scrollbar-thumb': {
              backgroundColor: theme.palette.divider
            },
            '&::-webkit-scrollbar-corner': {
              backgroundColor: theme.palette.background.paper
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: theme.palette.action.disabled
            },
            ':root': {
              '--color-logo-primary': theme.palette.primary.main,
              '--color-logo-info': theme.palette.info.main,
              '--color-logo-text': theme.palette.text.secondary
            }
          };
        }
      }), children]
    })
  });
};